import type React from "react";

import { Button } from "@/components/Button/Button";
import type { ModalBaseProps } from "@/components/Modal/Modal";
import { Modal } from "@/components/Modal/Modal";
import MultiLineContent from "@/components/MultiLineContent/MultiLineContent";
import { useTranslation } from "@/translations";

type SocialContributionWidgetActionsModalProps = ModalBaseProps;

export function SocialContributionWidgetActionsModal({
  isOpened,
  onOpenChange,
}: SocialContributionWidgetActionsModalProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <Modal.Root
      title={t("component.analytics-widget.social-contribution.action-modal.title")}
      {...{ isOpened, onOpenChange }}
    >
      <MultiLineContent className="py-2 leading-[180%]">
        {t("component.analytics-widget.social-contribution.action-modal.body")}
      </MultiLineContent>
      <Modal.Actions>
        <Modal.Close>
          <Button>{t("common.action.close")}</Button>
        </Modal.Close>
      </Modal.Actions>
    </Modal.Root>
  );
}
